import { useCallback } from 'react';

import storageService from '@lib/services/storageService';
import axiosClient from '@lib/utils/axiosClient';

export default function useSignOut() {
  // TODO danielmana retrieve module's path from the context once the ui-common is updated
  // const routingMap = useRoutingMap();
  const path = '/kiosk/:step';
  const step = 'login-by-contact'; // TODO danielmana use EContainerAuthPatientLoginStep
  const pathWithStep = path.replace(':step', step);

  const signOut = useCallback(async () => {
    const response = await axiosClient.get<{ id: string }>('/widgets/user');
    storageService.removeAuth();
    // TODO danielmana retrieve module's path from the context
    window.location.replace(`${pathWithStep}?user=${response.data?.id}`);
  }, [pathWithStep]);

  return signOut;
}
